// 新功能卡片的内容。登录后打开网站，没看过的条目会弹出来（components/WhatsNew.tsx）。
//
// 加一条：把新条目放在数组**最前面**，id 起个新的、永远不要复用 —— 看过的记录按 id 存，
// 复用旧 id 等于对看过的人静默。每条只写三样：标题、一句话说它是什么（intro）、一个例子（example），
// 再加一个去哪试（cta）。要短 —— 这是弹在脸上的提示，不是说明书，写不下的放文档里。
//
// 只写**新功能**：修 bug、改性能、重构都不进这里，用户不需要被它们打断。
// 功能是 asaptodo 这个站自己的能力，不是某个页面的功能；cta 只在有一个具体页面能马上试
// 的时候才给，没有就别硬凑一个（不要为了有按钮把人带到不相干的页面）。
//
// 数据放在文件里而不是数据库：更新跟着功能的 PR 一起提交，不会漏。

export type UpdateEntry = {
  id: string
  date: string
  tag: string
  title: string
  intro: string
  example: string
  cta?: { label: string; href: string }
}

export const UPDATES: UpdateEntry[] = [
  {
    id: '2026-10-30-input-center-collapse',
    date: '2026-10-30',
    tag: '待办',
    title: '输入条收起来了，在顶栏右上角',
    intro: '它不再一直占着屏幕底部。按 ⌘K（Windows 是 Ctrl+K）或点右上角那只小豆子就能叫回来。',
    example: '⌘K → 写一件事 → 回车',
    cta: { label: '去试试', href: '/todo/today' },
  },
  {
    id: '2026-10-29-shared-tool-data',
    date: '2026-10-29',
    tag: 'Recipe',
    title: 'Recipe 可以大家一起用了',
    intro: '发布时选「大家一起用」，你勾选的内容，所有添加的人都能看到。',
    example: '每日打卡里显示「今天 37 人打卡」',
  },
  {
    id: '2026-10-28-input-center',
    date: '2026-10-28',
    tag: '待办',
    title: '底部「一句话」输入条',
    intro: '按 / 唤起，写一句话就能记事、查事、改事。',
    example: '明天下午 交周报 #工作 !1',
    cta: { label: '去试试', href: '/todo/today' },
  },
  {
    id: '2026-10-27-ai-cowork-time',
    date: '2026-10-27',
    tag: '工作日志',
    title: 'AI 共创时间',
    intro: '工作日志自动记下和 AI 干了多久，需要升级 hook。',
    example: '问 AI「这周时间花在哪了」',
    cta: { label: '去看看', href: '/worklog' },
  },
  {
    id: '2026-10-22-todo-layout',
    date: '2026-10-22',
    tag: '待办',
    title: '待办页：详情栏可拖宽，项目可折叠',
    intro: '拖详情栏的边缘调宽，点左边的「项目」收起。',
    example: '长任务描述拖宽就不用来回滚',
    cta: { label: '去试试', href: '/todo/today' },
  },
]
